module.exports = __webpack_public_path__ + "media/img/pages/companies/groupe-mutuel-new-1def0f5372a2b5142943e4a3c03084f7.png";